import { useRef, useEffect } from "react";

const PositionedGraphBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    // Define left & right spawn zones
    const zones = [
      { x: 10, y: height * - 0.1, w: 300, h: height * 0.6 },        // left
      { x: width - 300, y: height * 0.1, w: 300, h: height * 0.6 } // right
    ];

    // Generate nodes inside zones
    const nodes = [];
    zones.forEach((zone) => {
      for (let i = 0; i < 20; i++) {
        nodes.push({
          x: zone.x + Math.random() * zone.w,
          y: zone.y + Math.random() * zone.h,
          vx: (Math.random() - 0.5) * 0.3,
          vy: (Math.random() - 0.5) * 0.3,
          radius: 4,
          color: Math.random() > 0.5 ? "#2A3C7B" : "#B52B2B",
          zone
        });
      }
    });

    function draw() {
      ctx.clearRect(0, 0, width, height);

      // Links
      for (let i = 0; i < nodes.length; i++) {
        for (let j = i + 1; j < nodes.length; j++) {
          const n1 = nodes[i];
          const n2 = nodes[j];

          // only link nodes inside the same zone
          if (n1.zone !== n2.zone) continue;

          const dx = n1.x - n2.x;
          const dy = n1.y - n2.y;
          const dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < 120) {
            ctx.strokeStyle = "rgba(180, 180, 180, 0.35)";
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(n1.x, n1.y);
            ctx.lineTo(n2.x, n2.y);
            ctx.stroke();
          }
        }
      }

      // Nodes
      nodes.forEach((n) => {
        ctx.beginPath();
        ctx.arc(n.x, n.y, n.radius, 0, Math.PI * 2);
        ctx.fillStyle = n.color;
        ctx.fill();

        // Move
        n.x += n.vx;
        n.y += n.vy;

        // Keep inside zone
        if (n.x < n.zone.x || n.x > n.zone.x + n.zone.w) n.vx *= -1;
        if (n.y < n.zone.y || n.y > n.zone.y + n.zone.h) n.vy *= -1;
      });

      requestAnimationFrame(draw);
    }

    draw();

    // Resize handler
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;

      // update zones on resize
      zones[0] = { x: 0, y: height * 0.2, w: 300, h: height * 0.6 };
      zones[1] = { x: width - 300, y: height * 0.2, w: 300, h: height * 0.6 };
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: -1,
        background: "#fff"
      }}
    />
  );
};

export default PositionedGraphBackground;
